<template>
  <XnFileInput
    class="flex-1 m-0 w-full max-w-max h-1/3 my-5 text-sm"
    :file-types="fileTypes"
    :required="required"
    :max-size="maxSize"
    :max-size-message="maxSizeMessage"
    @new-file-added="handleNewFile"
  >
    <div class="w-full flex flex-col text-center items-center z-10 py-5">
      <h5
        v-if="fileInfo"
        class="text-left leading-none absolute  left-2.5 top-2.5"
      >
        {{ fileInfo }}
      </h5>
      <h5
        v-else
        class="text-left leading-none absolute  left-2.5 top-2.5"
      >
        File Upload
      </h5>
      <br>
      <h2 class="leading-none uppercase">
        Drag file here or click Add File
      </h2>
      <button class="btn uppercase justify-self-end m-2 my-5">
        Add File
      </button>
      <p class="text-light text-xs">
        50MB Maximum Allowed Size Per File
      </p>
      <p class="z-10 text-light text-xs">
        {{ allowedFiles }} files ONLY. Please follow file guidelines
        <a
          class="text-secondary hover:text-white underline z-10"
          href="https://aproe.com/file-guidelines/"
          target="_blank"
          rel="noopener noreferrer"
        >here</a>
      </p>
    </div>
  </XnFileInput>
</template>
<script>
import XnFileInput from './primitives/XnFileInput.vue'
export default {
  name: 'AproeFileInput',
  components: {
    XnFileInput,
  },
  props: {
    required: { type: Boolean, default: () => true },
    fileTypes: {
      type: Array,
      default: () => {
        return ['.dxf', '.DXF']
      },
    },
    maxSize: { type: Number, default: () => 50000000 },
    maxSizeMessage: {
      type: String,
      default: () =>
        'Please directly request this file by emailing waterjet@aproe.com',
    },
    fileInfo: { type: String, default: () => '' },
  },
  computed: {
    allowedFiles () {
      return this.fileTypes.join(', ')
    },
  },
  methods: {
    handleNewFile (file) {
      this.$emit('new-file-added', file)
    },
  },
}
</script>
